import { Box, Typography } from '@mui/material';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutlined';
import LinkIcon from '@mui/icons-material/Link';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import { PieceHeading } from './PieceHeading';
import {
  HERO_TEXT_SECONDARY,
  HERO_ICON_BG,
  HERO_ICON_BORDER,
  HERO_ICON_COLOR,
} from '../designTokens';

const HIGHLIGHTS = [
  { label: 'Match people to projects by skill & availability', Icon: PeopleOutlineIcon },
  { label: 'Sync deals straight from your CRM',                Icon: LinkIcon },
  { label: 'Spot conflicts before they hit the calendar',      Icon: CalendarTodayIcon },
];

export function PieceHighlights() {
  return (
    <Box sx={{ maxWidth: 460 }}>
      <PieceHeading eyebrow="Resource planning" line1="Right people." line2="Right projects." />
      <Box
        component="ul"
        sx={{ listStyle: 'none', m: 0, p: 0, mt: 3.5, display: 'flex', flexDirection: 'column', gap: 1.5 }}
      >
        {HIGHLIGHTS.map(({ label, Icon }) => (
          <Box key={label} component="li" sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Box
              sx={{
                width: 22,
                height: 22,
                borderRadius: '6px',
                background: HERO_ICON_BG,
                border: `1px solid ${HERO_ICON_BORDER}`,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: HERO_ICON_COLOR,
                flexShrink: 0,
              }}
            >
              <Icon sx={{ fontSize: 14 }} />
            </Box>
            <Typography component="span" sx={{ fontSize: '0.8125rem', color: HERO_TEXT_SECONDARY }}>
              {label}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
